export const transformCoordinates = (point) => {
    // Using reverse on the leaflet point was the mistake, modifying IN PLACE the geojson point in the geojson layer, thus two layers added : one in africa, one in France at the correct place.
    // Once fixed, I had to fix the duplicates issue
    if (point.length >= 2) {
        return [point[1], point[0]];
    }
    return point
}
